<div class="copo-container settings-general">
	<div class="manage-service-container" *ngIf="enableManageServices && userServiceInfoSelected">
		<button type="button" mat-button color="accent"
			class="service-button"
			[routerLink]="['/user/card',getRouteParam(),'manage-service', userServiceInfoSelected.id]"><span class="text-color" translate>settings.manage-services </span>
			<mat-icon iconPositionEnd svgIcon="md:edit" class="icon-color"></mat-icon>
		</button>
	</div>
	<div class="card-block">
		<div class="card-title title-container">
			<div class="card-title-label header" translate>userServiceInfo.services.management</div>
			<mat-form-field class="organization-list-form">
				<mat-label translate>datacenter-filter.organization-name</mat-label>
				<mat-select [formControl]="organizationControl" (selectionChange)="handleOrganizationServicesUpdated($event.value)">
					<mat-option *ngFor="let userServicesOrganization of userServicesOrganizations" [value]="userServicesOrganization">
						{{ userServicesOrganization.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="copo-card-grid-container">
			<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridOptions" [modules]="modules"
			(gridReady)="onGridReady($event)" (viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
		</div>
	</div>
</div>